import './Paginate.scss';
import Component from './Paginate.js';
export default Component;